require("./graphic");

var _zrender = require("../zrender");

var registerPainter = _zrender.registerPainter;

var Painter = require("./Painter");

registerPainter('svg', Painter);


//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/svg/svg.js
// module id = 2277
// module chunks = 136